var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWorkshop(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_159_8038)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.7301 32.27C16.1266 32.27 18.8801 29.5165 18.8801 26.12C18.8801 22.7234 16.1266 19.97 12.7301 19.97C9.33353 19.97 6.58008 22.7234 6.58008 26.12C6.58008 29.5165 9.33353 32.27 12.7301 32.27Z",
    stroke: "white",
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.0101 32.4C18.7401 32.4 23.4001 37.05 23.4001 42.79V44.39H2.62012V42.79C2.62012 37.06 7.27012 32.4 13.0101 32.4Z",
    stroke: "white",
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.99 54.43V44.52H2.5V54.43",
    stroke: "white",
    strokeWidth: 5,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59 8H31V34H59",
    stroke: "white",
    strokeWidth: 5,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.5095 18L51.4295 22.45L46.3495 18.64L41.2695 23.08",
    stroke: "white",
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_159_8038"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 59.27,
    height: 49.43,
    fill: "white",
    transform: "translate(0 5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWorkshop);
export default __webpack_public_path__ + "static/media/workshop.ff261e3b48d945ed2eefa802782ec60f.svg";
export { ForwardRef as ReactComponent };